var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKey(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 130 200",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_key-solutions_1249090",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    className: "a",
    transform: "translate(25.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,64.557 C26.605,64.557 15.708,53.66 15.708,40.263 C15.708,26.869 26.604,15.971 40,15.971 C53.396,15.971 64.294,26.868 64.294,40.263 C64.294,53.66 53.396,64.557 40,64.557 Z M40,22.298 C30.095,22.298 22.035,30.356 22.035,40.263 C22.035,50.171 30.095,58.23 40,58.23 C49.906,58.23 57.968,50.17 57.968,40.263 C57.968,30.356 49.906,22.298 40,22.298 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.121,176 L28.881,176 L28.881,78.293 C12.221,73.413 0.377,57.813 0.377,40.263 C0.377,18.418 18.152,0.646 40,0.646 C61.845,0.646 79.617,18.418 79.617,40.263 C79.617,57.814 67.777,73.413 51.121,78.293 L51.121,123.273 L74.927,123.273 L74.927,142.858 L63.029,142.858 L63.029,149.786 L74.927,149.786 L74.927,169.368 L51.121,169.368 L51.121,176 Z M35.208,169.673 L44.795,169.673 L44.795,163.041 L68.6,163.041 L68.6,156.113 L56.702,156.113 L56.702,136.531 L68.6,136.531 L68.6,129.6 L44.795,129.6 L44.795,73.308 L47.271,72.756 C62.348,69.398 73.291,55.732 73.291,40.264 C73.291,21.908 58.356,6.973 40.001,6.973 C21.641,6.973 6.705,21.908 6.705,40.264 C6.705,55.732 17.652,69.397 32.735,72.756 L35.209,73.308 L35.209,169.673 L35.208,169.673 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 61.836,
    y: 0,
    width: 6.327,
    height: 13.903
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(43.063209, 11.313423) rotate(67.504865) translate(-43.063209, -11.313423) ",
    x: 36.1112994,
    y: 8.14996367,
    width: 13.903819,
    height: 6.32691765
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(24.470315, 23.740532) rotate(45.008103) translate(-24.470315, -23.740532) ",
    x: 17.5178819,
    y: 20.5765621,
    width: 13.9048668,
    height: 6.32793938
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(12.051943, 42.335076) rotate(22.500428) translate(-12.051943, -42.335076) ",
    x: 5.09976716,
    y: 39.1709962,
    width: 13.9043511,
    height: 6.32815978
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.734,
    y: 61.105,
    width: 13.903,
    height: 6.327
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(12.052623, 86.202495) rotate(67.504865) translate(-12.052623, -86.202495) ",
    x: 8.88866403,
    y: 79.2510859,
    width: 6.32791764,
    height: 13.9028191
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(24.468567, 104.793378) rotate(45.000000) translate(-24.468567, -104.793378) ",
    x: 21.3055977,
    y: 97.8429443,
    width: 6.32593933,
    height: 13.9008667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(86.934156, 11.311324) rotate(22.482355) translate(-86.934156, -11.311324) ",
    x: 83.7706473,
    y: 4.36030398,
    width: 6.32701822,
    height: 13.90204
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(105.520655, 23.741942) rotate(45.000000) translate(-105.520655, -23.741942) ",
    x: 102.357686,
    y: 16.7885088,
    width: 6.32593933,
    height: 13.9068666
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(117.949258, 42.332632) rotate(67.486792) translate(-117.949258, -42.332632) ",
    x: 114.786728,
    y: 35.3810663,
    width: 6.32505961,
    height: 13.903131
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 115.359,
    y: 61.098,
    width: 13.906,
    height: 6.327
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(117.941800, 86.199134) rotate(22.495135) translate(-117.941800, -86.199134) ",
    x: 110.989891,
    y: 83.0356749,
    width: 13.903819,
    height: 6.32691765
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(105.527179, 104.789011) rotate(45.000000) translate(-105.527179, -104.789011) ",
    x: 98.5737458,
    y: 101.626042,
    width: 13.9068666,
    height: 6.32593933
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.9a36fa98.svg";
export { ForwardRef as ReactComponent };